/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as CodeRouteImport } from './routes/code'
import { Route as ConsentRouteImport } from './routes/consent'
import { Route as ContinueRouteImport } from './routes/continue'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LegalIndexRouteImport } from './routes/legal.index'
import { Route as LegalKeyRouteImport } from './routes/legal.$key'
import { Route as RefCodeRouteImport } from './routes/ref.$code'
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password_.$token'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const CodeRoute = CodeRouteImport.update({
  id: '/code',
  path: '/code',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsentRoute = ConsentRouteImport.update({
  id: '/consent',
  path: '/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const ContinueRoute = ContinueRouteImport.update({
  id: '/continue',
  path: '/continue',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalIndexRoute = LegalIndexRouteImport.update({
  id: '/legal/',
  path: '/legal/',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalKeyRoute = LegalKeyRouteImport.update({
  id: '/legal/$key',
  path: '/legal/$key',
  getParentRoute: () => rootRouteImport,
} as any)
const RefCodeRoute = RefCodeRouteImport.update({
  id: '/ref/$code',
  path: '/ref/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/reset-password_/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/code': typeof CodeRoute
  '/consent': typeof ConsentRoute
  '/continue': typeof ContinueRoute
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/legal/$key': typeof LegalKeyRoute
  '/ref/$code': typeof RefCodeRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/legal/': typeof LegalIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/code': typeof CodeRoute
  '/consent': typeof ConsentRoute
  '/continue': typeof ContinueRoute
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/legal/$key': typeof LegalKeyRoute
  '/ref/$code': typeof RefCodeRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/legal': typeof LegalIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/code': typeof CodeRoute
  '/consent': typeof ConsentRoute
  '/continue': typeof ContinueRoute
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/legal/$key': typeof LegalKeyRoute
  '/ref/$code': typeof RefCodeRoute
  '/reset-password_/$token': typeof ResetPasswordTokenRoute
  '/legal/': typeof LegalIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/code'
    | '/consent'
    | '/continue'
    | '/error'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/legal/$key'
    | '/ref/$code'
    | '/reset-password/$token'
    | '/legal/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/code'
    | '/consent'
    | '/continue'
    | '/error'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/legal/$key'
    | '/ref/$code'
    | '/reset-password/$token'
    | '/legal'
  id:
    | '__root__'
    | '/'
    | '/callback'
    | '/code'
    | '/consent'
    | '/continue'
    | '/error'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/legal/$key'
    | '/ref/$code'
    | '/reset-password_/$token'
    | '/legal/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CallbackRoute: typeof CallbackRoute
  CodeRoute: typeof CodeRoute
  ConsentRoute: typeof ConsentRoute
  ContinueRoute: typeof ContinueRoute
  ErrorRoute: typeof ErrorRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  LegalKeyRoute: typeof LegalKeyRoute
  RefCodeRoute: typeof RefCodeRoute
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
  LegalIndexRoute: typeof LegalIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/code': {
      id: '/code'
      path: '/code'
      fullPath: '/code'
      preLoaderRoute: typeof CodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consent': {
      id: '/consent'
      path: '/consent'
      fullPath: '/consent'
      preLoaderRoute: typeof ConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/continue': {
      id: '/continue'
      path: '/continue'
      fullPath: '/continue'
      preLoaderRoute: typeof ContinueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/': {
      id: '/legal/'
      path: '/legal'
      fullPath: '/legal/'
      preLoaderRoute: typeof LegalIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/$key': {
      id: '/legal/$key'
      path: '/legal/$key'
      fullPath: '/legal/$key'
      preLoaderRoute: typeof LegalKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ref/$code': {
      id: '/ref/$code'
      path: '/ref/$code'
      fullPath: '/ref/$code'
      preLoaderRoute: typeof RefCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password_/$token': {
      id: '/reset-password_/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CallbackRoute: CallbackRoute,
  CodeRoute: CodeRoute,
  ConsentRoute: ConsentRoute,
  ContinueRoute: ContinueRoute,
  ErrorRoute: ErrorRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  LegalKeyRoute: LegalKeyRoute,
  RefCodeRoute: RefCodeRoute,
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
  LegalIndexRoute: LegalIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
